import React from "react";

/**
 * Dialog component for displaying species information
 * Shows species details in a modal overlay
 * 
 * @param {boolean} isOpen - Dialog open state
 * @param {Object} species - Selected species object
 * @param {Function} onClose - Close handler
 */
export default function SpeciesDialog({ isOpen, species, onClose }) {
    if (!isOpen || !species) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-offwhite rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-sage">
                    <h2 className="text-2xl font-heading font-bold text-forest">
                        {species.name}
                    </h2>
                </div>
                <div className="p-6">
                    <p className="text-charcoal font-body leading-relaxed">
                        {species.description}
                    </p>
                </div>
                <div className="p-6 border-t border-sage flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-forest text-offwhite rounded-lg hover:bg-leaf transition-colors font-semibold"
                    >
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    );
}
